import { rei, auth } from "@/services/api"

class BryService {
  static makeChallenge () {
    return auth.get(`auth-challenge`).then(res => res.data)
  }

  static prepareContentForSignature (base64Content, nonce) {
    return {
      nonce,
      hashes: [
        base64Content
      ]
    }
  }

  static signBase64Content (certId, signatures, nonceBatch) {
    const input = {
      nonce: nonceBatch,
      algoritmoHash: 'SHA256',
      formatoDadosEntrada: 'BASE64',
      formatoDadosSaida: 'BASE64',
      assinaturas: Array.isArray(signatures) ? signatures : [signatures]
    }

    return BryExtension.sign(certId, JSON.stringify(input))
  }

  static validateChallenge (challenge, signedChallenge, certificate) {
    return auth
      .post(`validate-challenge`, {
        challenge,
        signedChallenge,
        certificate
      })
      .then((response) => response.data)
  }

  static async auth ({ certId, certificateData }) {
    let challenge, signature = null

    try {
      challenge = await this.makeChallenge()
    } catch (e) {
      throw new Error('Não foi possível gerar o token de autenticação')
    }

    try {
      signature = await this.signBase64Content(certId, this.prepareContentForSignature(challenge.challenge))
    } catch ({ code, description }) {
      throw new Error(`${code} - ${description}`)
    }

    const signedChallenge = signature.assinaturas[0].hashes[0]

    return this.validateChallenge(challenge.challenge, signedChallenge, certificateData)
  }

  static startSigning (certificate, documentos) {
    return rei.post('assinaturas/iniciar-assinatura', {
      certificate,
      documentos: Array.isArray(documentos) ? documentos : [documentos]
    }).then((response) => response.data)
  }

  static endSigning (bryNonce, signatures) {
    const data = {
      bryNonce,
      signatures
    }

    return rei.post(`assinaturas/finalizar-assinatura`, data).then(res => res.data)
  }

  static getExtension () {
    const isFirefox = typeof InstallTrigger !== 'undefined'
    const isChrome = !!window.chrome

    if (isFirefox) {
      window.location.href = this.FIREFOX_EXTENSION_URL
    } else if (isChrome) {
      window.open(this.CHROME_EXTENSION_URL, '_blank')
    } else {
      throw new Error('A extensão para assinatura digital não está disponível para seu navegador.')
    }
  }

  static isExtensionInstalled () {
    return (typeof BryExtension !== 'undefined' &&
      typeof BryExtension.listCertificates === 'function')
  }

  static getCertificates () {
    return BryExtension.listCertificates().then((certificates) => {
      return certificates.filter((certificate) => certificate.validity === 'VALID')
    })
  }
}

BryService.FIREFOX_EXTENSION_URL = 'https://www.bry.com.br/downloads/extension/firefox/assinatura_digital_bry.xpi'
BryService.CHROME_EXTENSION_URL = 'https://chrome.google.com/webstore/detail/dhikfimimcjpoaliefjlffaebdeomeni'

export default BryService
